class DarkModeToggle extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    
    if (this.button) {
      this.button.addEventListener('click', () => this.toggleMode());
      // Run initialization to sync button state with HTML attribute
      this.init();
    }
  }

  init() {
    // 1. Check what theme is CURRENTLY active 
    // (This was already decided by the critical script in theme.liquid based on Merchant Settings)
    const currentTheme = document.documentElement.getAttribute('data-theme');
    
    // 2. Set the button state to match
    if (currentTheme === 'dark') {
      this.button.setAttribute('aria-pressed', 'true');
    } else {
      this.button.setAttribute('aria-pressed', 'false');
    }
  }

  toggleMode() {
    const currentTheme = document.documentElement.getAttribute('data-theme');
    const newTheme = currentTheme === 'dark' ? 'light' : 'dark';

    // 1. Apply to HTML tag (CSS handles the colors)
    document.documentElement.setAttribute('data-theme', newTheme);
    
    // 2. Save preference to LocalStorage (User choice overrides everything)
    localStorage.setItem('theme', newTheme);
    
    // 3. Update accessibility state
    const isDark = newTheme === 'dark';
    this.button.setAttribute('aria-pressed', isDark);

    // 4. Dispatch event for other components if needed
    window.dispatchEvent(new Event('theme-change'));
  }
}

customElements.define('dark-mode-toggle', DarkModeToggle);